'use strict';

/**
 * Appointment time slots. A booking's slot id is its position in the master slot list
 * (0 = "06:00-08:00" ... 6 = "18:00-20:00" ...), so labels always come from that list, never typed in.
 * layout(slots, ids) gives the columns to show: every slot in order, plus "Other" when some bookings have
 * a slot id that is not in the list (e.g. -1 in old data), so no booking is ever left out.
 */
angular.module('scrapQcrmApp')
  .factory('slotList', function ($q, SellNow) {
    var cached = null;

    // the slot list, loaded once; a failed load is tried again next time
    function load() {
      if (!cached) {
        cached = SellNow.getSlots().then(function (res) {
          var all = res && res.status === 'SUCCESS' && res.data && res.data.allSlots;
          if (!all || !all.length) {
            return $q.reject('no slots');
          }
          return all.map(function (s) {
            return { id: Number(s.slotId), name: s.slotName };
          });
        }).catch(function (err) {
          cached = null;
          return $q.reject(err);
        });
      }
      return cached;
    }

    function startHour(name) {
      var m = /^(\d{1,2}):/.exec(name || '');
      return m ? Number(m[1]) : null;
    }

    // slots: from load(), or null when it failed (then the columns are "Slot 1", "Slot 2", ...)
    // ids: the slot ids that have bookings
    function layout(slots, ids) {
      var cols = [], known = {}, hasOther = false;
      if (slots) {
        slots.forEach(function (s) {
          var h = startHour(s.name), parts = (s.name || '').split(/\s*-\s*/);
          known[s.id] = true;
          // label "18:00–20:00"; from / to for two-line table headers
          cols.push({ key: String(s.id), label: parts.join('–'), from: parts[0], to: parts.length > 1 ? '–' + parts.slice(1).join('–') : '',
            title: s.name, night: h !== null && (h < 6 || h >= 18) });
        });
      } else {
        var max = 5;
        ids.forEach(function (id) {
          if (isValidId(id) && id > max) { max = id; }
        });
        for (var i = 0; i <= max; i++) {
          known[i] = true;
          cols.push({ key: String(i), label: 'Slot ' + (i + 1), from: 'Slot ' + (i + 1), to: '', title: 'Slot ' + (i + 1), night: false });
        }
      }
      ids.forEach(function (id) {
        if (!(isValidId(id) && known[id])) { hasOther = true; }
      });
      if (hasOther) {
        cols.push({ key: 'other', label: 'Other', from: 'Other', to: '', title: 'Appointments without a valid time slot', night: false, other: true });
      }
      return {
        cols: cols,
        keyFor: function (id) {
          return isValidId(id) && known[id] ? String(id) : 'other';
        }
      };
    }

    function isValidId(id) {
      return typeof id === 'number' && isFinite(id) && id >= 0 && Math.floor(id) === id;
    }

    // slot id from an API value ("6", 6, null, ...); anything else is NaN and goes to "Other"
    function toId(v) {
      return (v === null || v === undefined || v === '') ? NaN : Number(v);
    }

    return { load: load, layout: layout, toId: toId };
  });
